import usePatientMeta from './usePatientMeta';
import { Meta } from '../../../graphql/graphql';

export default function usePatientDiagnosisMeta({
	original,
	virtual,
}: {
	original: { id: string; meta?: Meta[] };
	virtual: { id: string; meta?: Meta[] };
}) {
	const {
		reFetchMeta: refetchVirtualMeta,
		patientDiagnosis: virtualPatientDiagnosis,
		metaIsLoading: virtualMetaIsLoading,
	} = usePatientMeta(virtual.id, virtual.meta);
	const {
		reFetchMeta: refetchOriginalMeta,
		patientDiagnosis: originalPatientDiagnosis,
		metaIsLoading: originalMetaIsLoading,
	} = usePatientMeta(original.id, original.meta);

	const refetchMetas = async () => {
		await refetchVirtualMeta();
		await refetchOriginalMeta();
	};

	return {
		reFetchMeta: refetchMetas,
		patientDiagnosis: originalPatientDiagnosis ?? virtualPatientDiagnosis,
		metaIsLoading: originalMetaIsLoading || virtualMetaIsLoading,
	};
}
